<template>
   <div class='dashboard-toggler' @click="toggleMode" :title="`Click to change to ${getOtherMode} mode`">
      <div class='icon-wrapper'>
         <img v-if="isDashboardMode" src="../../../../assets/icons/expand.svg"/>
         <img v-else src='../../../../assets/icons/shrink.svg'/>
      </div>
      <span>{{ getOtherMode }}</span>
   </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';

export default {
   computed: {
      ...mapGetters(['isDashboardMode', 'getOtherMode'])
   },
   methods: {
      ...mapActions(['toggleMode']),
   },
}
</script>

<style lang="scss" scoped>

.dashboard-toggler {
   position: absolute;
   z-index: 1;
   margin: 2px;
   margin-bottom: 0;
   width: max-content;
   padding: 4px;
   cursor: pointer;
   display: flex;
   align-items: center;
   z-index: 1;

   .icon-wrapper {
      width: 2.2em;
      height: 2.2em;
      background: lighten($primary-color, 5%);
      border-radius: 50%;
      border: solid 3px white;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: -5px 5px 5px rgba(0,0,0,0.2);
      transition: all 0.3s ease;
   }
   span {
      color: white;
      margin-left: 2px;
      font-size: 12px;
      font-family: $secondary-font;
      font-weight: 600;
      text-shadow: 0.5px 0.5px 2px rgba(0,0,0,0.5);
      transition: all 0.3s ease;
   }
   &:hover {
      .icon-wrapper {
         box-shadow: -5px 5px 5px rgba(0,0,0,0.3);
         transform: translateY(-2px);//  scale(1.05);
      }
      span {
         transform: scale(1.2) translate(0.3em, -2px);
         text-shadow: 1px 1px 2px rgba(0,0,0,0.6);
      }
   }
}
</style>